export const GA_ID = 'G-V626EQQW6D';

export const pageview = (url) => {
  window.gtag('config', GA_ID, {
    page_path: url,
  });
}; 